var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"card-header"},[_vm._t("default"),_vm._v(" "),(_vm.hasCross)?_c('i',{staticClass:"s-cross",on:{"click":function($event){return _vm.$emit('close')}}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }